export const MediationEligibility = {
    boxKey: 'MEDIATION.ELIGIBLE_BOX',
    docReqHeaderKey: 'MEDIATION.DOC_REQ_H',
    docRequirements: [
        'MEDIATION.DOC_INV',
        'MEDIATION.DOC_LPO',
        'MEDIATION.DOC_DN',
        'MEDIATION.DOC_CORR',
        'MEDIATION.DOC_CONTRACT',
        'MEDIATION.DOC_STATEMENT',
        'MEDIATION.DOC_QUOTATION',
        'MEDIATION.DOC_LC',
        'MEDIATION.DOC_BL'
    ],
    addDocHeaderKey: 'MEDIATION.ADD_DOC_H',
    addDocuments: [
        'MEDIATION.ADD_DOC_POA',
        'MEDIATION.ADD_DOC_TR_LICENSE',
        'MEDIATION.ADD_DOC_MANAGER',
        'MEDIATION.ADD_DOC_CERT'
    ],
    feeHeaderKey: 'MEDIATION.FEE_H',
    feeTable: [
        {
            groupKey: 'MEDIATION.MEMBERS',
            rows: [
                { labelKey: 'MEDIATION.REG_FEES', valueKey: 'MEDIATION.REG_FEE_MEM' },
                { labelKey: 'MEDIATION.ADMIN_FEES', valueKey: 'MEDIATION.ADMIN_FEE_MEM' }
            ]
        },
        {
            groupKey: 'MEDIATION.NON_MEMBERS',
            rows: [
                { labelKey: 'MEDIATION.REG_FEES', valueKey: 'MEDIATION.REG_FEE_NON' },
                { labelKey: 'MEDIATION.ADMIN_FEES', valueKey: 'MEDIATION.ADMIN_FEE_NON' }
            ]
        }
    ],
    noteKey: 'MEDIATION.FEE_NOTE',
    agreeKey: 'MEDIATION.AGREE',
    termsKey: 'MEDIATION.TERMS',
    btnKey: 'MEDIATION.BTN_PROCEED'
};
